import axios from "axios";
import { HandlersAuthResponse } from "../generated/models/handlers-auth-response";
import { HandlersUserCreate } from "../generated/models/handlers-user-create";
import { HandlersUserLogin } from "../generated/models/handlers-user-login";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://tab-black-dream-2270.fly.dev/api"
    : "http://localhost:8080/api";

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  login: async (
    credentials: HandlersUserLogin
  ): Promise<HandlersAuthResponse> => {
    const response = await api.post<HandlersAuthResponse>(
      "/auth/login",
      credentials
    );
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
    }
    return response.data;
  },

  register: async (
    userData: HandlersUserCreate
  ): Promise<HandlersAuthResponse> => {
    const response = await api.post<HandlersAuthResponse>(
      "/auth/register",
      userData
    );
    if (response.data.token) {
      localStorage.setItem("token", response.data.token);
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem("token");
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem("token");
  },
};
